'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@reactables/core');
var rxjs = require('rxjs');
var operators = require('rxjs/operators');
var forms = require('@reactables/forms');
var utilities = require('@jauntin/utilities');
var isEqual = require('lodash.isequal');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var isEqual__default = /*#__PURE__*/_interopDefaultLegacy(isEqual);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var _a, _b;
var rxDebug = ((_a = process.env.REACT_APP_RX_DEBUG) === null || _a === void 0 ? void 0 : _a.split(' ')) || [];
var rxDebugExclude = ((_b = process.env.REACT_APP_RX_DEBUG_EXCLUDE) === null || _b === void 0 ? void 0 : _b.split(' ')) || [];
var isRxDebugOn = function (name) {
    return (rxDebug.includes('*') || rxDebug.includes(name)) &&
        !rxDebugExclude.includes(name);
};

var RxBuilder = function (config) {
    return core.RxBuilder(__assign({ debug: isRxDebugOn(config.name) }, config));
};

var loadableInitialState = {
    loading: false,
    data: null,
    success: false,
    error: null
};
var load$1 = function (state) { return (__assign(__assign({}, state), { loading: true })); };
var loadSuccess = function (state, action) { return (__assign(__assign({}, state), { loading: false, data: (action === null || action === void 0 ? void 0 : action.payload) || null, success: true, error: null })); };
var loadError = function (state, action) { return (__assign(__assign({}, state), { loading: false, success: false, error: action.payload })); };

var index$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    load: load$1,
    loadError: loadError,
    loadSuccess: loadSuccess,
    loadableInitialState: loadableInitialState
});

var EXPIRED_QUOTE_VERSION = 'expiredQuoteVersion';

/**
 * @description Loads a quote and manages loading state.
 * Also runs success callback if provided
 */
var RxQuoteLoader = function (priceService, _a) {
    var quoteId = _a.quoteId, onLoadSuccess = _a.onLoadSuccess;
    return RxBuilder({
        initialState: loadableInitialState,
        name: 'rxQuoteLoader',
        sources: {
            load: rxjs.of(quoteId)
        },
        reducers: {
            load: {
                reducer: load$1,
                effects: [
                    function (actions$) {
                        return actions$.pipe(operators.mergeMap(function (_a) {
                            var payload = _a.payload;
                            return rxjs.from(priceService.getSavedQuote(payload));
                        }), operators.tap(function (_a) {
                            var data = _a.data;
                            onLoadSuccess && onLoadSuccess(data);
                        }), operators.map(function () { return ({ type: 'loadSuccess' }); }), operators.catchError(function (error) {
                            var _a, _b;
                            if (error === EXPIRED_QUOTE_VERSION ||
                                ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 422 ||
                                ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                                return rxjs.of({ type: 'loadError', payload: 'invalidQuote' });
                            }
                            else {
                                return rxjs.of({
                                    type: 'loadError',
                                    payload: 'genericServerError'
                                });
                            }
                        }));
                    },
                ]
            },
            loadSuccess: loadSuccess,
            loadError: loadError
        }
    });
};

var build = function (config, options) {
    return forms.build(config, __assign({ debug: isRxDebugOn(options === null || options === void 0 ? void 0 : options.name) }, options));
};
var load = function (form, options) {
    return forms.load(form, __assign({ debug: isRxDebugOn(options === null || options === void 0 ? void 0 : options.name) }, options));
};

var formBuilders = /*#__PURE__*/Object.freeze({
    __proto__: null,
    build: build,
    load: load
});

/**
 * @description Resets form controls
 * Operator rehydrates an RxForm to resets controls
 */
var resetFormControls = function (refs, // Controls to be reset
providers) {
    if (refs === void 0) { refs = []; }
    return function (form$) {
        return form$.pipe(operators.mergeMap(function (form) {
            // Rehydrate a RxForm so we can clear out sensitive fields.
            var rxFormState$ = load(form, {
                name: 'rxResetFormControls',
                sources: {
                    clearFields: rxjs.of({})
                },
                providers: providers,
                reducers: {
                    clearFields: function (_a, state) {
                        var resetControl = _a.resetControl;
                        return refs.reduce(function (acc, ref) {
                            return resetControl(acc, ref);
                        }, state);
                    }
                }
            })[0];
            // We can skip form initialization state since we just want the cleared form
            return rxFormState$.pipe(operators.skip(1), operators.take(1));
        }));
    };
};

/**
 * @description
 * Resets sensitive info and saves a coverage application quote to server
 */
var RxQuoteSaver = function (priceService, options) {
    var _a = build(forms.control(['', ['email', 'required']]), { name: 'rxQuoteSaverForm' }), emailForm$ = _a[0], emailFormActions = _a[1];
    var _b = RxBuilder({
        name: 'rxQuoteSaver',
        initialState: loadableInitialState,
        reducers: {
            saveQuote: {
                reducer: load$1,
                effects: [
                    function (actions$) {
                        return actions$.pipe(operators.switchMap(function (_a) {
                            var payload = _a.payload;
                            return rxjs.of(payload.data.state.applicationForm).pipe(resetFormControls(options.resetControls, options.providers), operators.mergeMap(function (clearedApplicationForm) {
                                var newPayload = __assign(__assign({}, payload), { data: __assign(__assign({}, payload.data), { state: __assign(__assign({}, payload.data.state), { applicationForm: clearedApplicationForm }) }) });
                                if (options.postFormReset) {
                                    newPayload = options.postFormReset(newPayload);
                                }
                                return rxjs.from(priceService.saveQuote(newPayload)).pipe(operators.map(function () { return ({ type: 'saveQuoteSuccess' }); }), operators.catchError(function (error) {
                                    return rxjs.of({ type: 'saveQuoteFailure', payload: error });
                                }));
                            }));
                        }));
                    },
                ]
            },
            saveQuoteSuccess: loadSuccess,
            saveQuoteFailure: loadError
        }
    }), quoteSaver$ = _b[0], quoteSaverActions = _b[1];
    return [
        rxjs.combineLatest([emailForm$, quoteSaver$]).pipe(operators.map(function (_a) {
            var emailForm = _a[0], rxQuoteSaver = _a[1];
            return (__assign({ emailForm: emailForm }, rxQuoteSaver));
        })),
        __assign({ emailForm: emailFormActions }, quoteSaverActions),
    ];
};

function attemptsGuardFactory(maxAttempts) {
    return function (attemptsCount) {
        if (attemptsCount > maxAttempts) {
            throw new Error('Exceeded maxAttempts');
        }
    };
}
/**
 * @description polls a source while isPollingActive returns true
 */
function pollWhile(_a) {
    var source = _a.source, isPollingActive = _a.isPollingActive, _b = _a.pollInterval, pollInterval = _b === void 0 ? 2000 : _b, // in ms
    _c = _a.maxAttempts, // in ms
    maxAttempts = _c === void 0 ? 30 : _c, _d = _a.emitOnlyLast, emitOnlyLast = _d === void 0 ? false : _d;
    return function () {
        var poll$ = rxjs.timer(0, pollInterval).pipe(operators.scan(function (attempts) { return ++attempts; }, 0), operators.tap(attemptsGuardFactory(maxAttempts)), operators.switchMap(function () { return source(); }), operators.takeWhile(isPollingActive, true));
        return emitOnlyLast ? poll$.pipe(operators.last()) : poll$;
    };
}

/**
 * @description Manages simple toggle state
 */
var RxToggle = function (initialState, options) {
    if (initialState === void 0) { initialState = false; }
    return RxBuilder({
        initialState: initialState,
        name: 'rxToggle',
        sources: options === null || options === void 0 ? void 0 : options.sources,
        reducers: __assign({ toggleOn: function () { return true; }, toggleOff: function () { return false; }, toggle: function (state) { return !state; } }, options === null || options === void 0 ? void 0 : options.reducers)
    });
};

/**
 * @description creates a dictionary of ValidatorAsyncFn to be used
 * in a reactable form configuration
 */
var asyncValidator = function (_a) {
    var _b;
    var name = _a.name, resource = _a.resource, _c = _a.debounceTime, debounceTime = _c === void 0 ? 500 : _c;
    return (_b = {},
        _b[name] = function (control$) {
            return control$.pipe(operators.filter(function (_a) {
                var validatorErrors = _a.validatorErrors;
                return Object.values(validatorErrors).every(function (error) { return !error; });
            }), // Filter out values that don't pass the ValidatorFns
            operators.debounceTime(debounceTime), operators.switchMap(function (_a) {
                var _b;
                var value = _a.value, dirty = _a.dirty;
                if (!dirty || !value) {
                    //If the value has not changed or is empty on edit - resolve no error
                    return rxjs.of((_b = {}, _b[name] = false, _b));
                }
                return resource(value).pipe(operators.map(function (isValid) {
                    var _a;
                    return (_a = {}, _a[name] = !isValid, _a);
                }), operators.catchError(function () { return rxjs.of({ apiError: true }); }));
            }));
        },
        _b);
};
/**
 * @description creates a dictionary of ValidatorAsyncFn from an array of AsyncValidatorConfig
 */
var asyncValidators = function (asyncValidators) {
    return asyncValidators.reduce(function (acc, config) {
        return __assign(__assign({}, acc), asyncValidator(config));
    }, {});
};

/**
 * @description maps validators into ValidatorFns to be used with @reactable/forms
 */
var validatorFns = function () {
    return Object.entries(utilities.validators).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], validator = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = function (value) {
            var _a;
            return (_a = {},
                _a[key] = Boolean(validator(value, undefined)),
                _a);
        }, _b)));
    }, {});
};

/**
 * @description Countdown timer.
 * Counts down in seconds by default.
 * Adjust interval for different units
 * Example: For minutes - interval = 60
 */
var RxTimer = function (_a) {
    var time = _a.time, _b = _a.interval, interval = _b === void 0 ? 1 : _b;
    return RxBuilder({
        name: 'rxTimer',
        sources: {
            timerChange: rxjs.timer(0, interval * 1000)
        },
        initialState: { timeRemaining: time, timesUp: false },
        reducers: {
            timerChange: function (state) {
                var diff = state.timeRemaining - 1;
                var timesUp = diff <= 0;
                return {
                    timeRemaining: diff < 0 ? 0 : diff,
                    timesUp: timesUp
                };
            },
            resetTimer: function () { return ({ timeRemaining: time, timesUp: false }); }
        }
    });
};

/**
 * @description Given an effect or resource,
 * RxRequest sends the request and handles loading, success and error states
 */
var RxRequest = function (options) {
    var _a = options.name, name = _a === void 0 ? 'rxRequest' : _a, _b = options.initialState, initialState = _b === void 0 ? loadableInitialState : _b, _c = options.sources, sources = _c === void 0 ? [] : _c, reducers = options.reducers, _d = options.catchError, catchError = _d === void 0 ? function () { return rxjs.of({ type: 'sendFailure', payload: true }); } : _d;
    var effect;
    if (options.effect) {
        effect = options.effect;
    }
    else {
        effect = function (actions$) {
            return actions$.pipe(operators.map(function (_a) {
                var payload = _a.payload;
                return rxjs.from(options.resource(payload));
            }));
        };
    }
    return RxBuilder({
        name: name,
        initialState: initialState,
        sources: sources,
        reducers: __assign({ send: {
                reducer: load$1,
                effects: [
                    function (send$) {
                        return send$.pipe(effect, operators.switchMap(function (request$) {
                            return request$.pipe(operators.map(function (response) { return ({
                                type: 'sendSuccess',
                                payload: response
                            }); }), operators.catchError(catchError));
                        }));
                    },
                ]
            }, sendSuccess: loadSuccess, sendFailure: loadError, resetState: function () { return loadableInitialState; } }, reducers)
    });
};

/**
 *@description reactable that listens for search criteria changes and performs
 * paginated search.
 */
var RxPaginatedSearch = function (_a) {
    var resource = _a.resource, searchConfig = _a.searchConfig, onSearchChange = _a.onSearchChange, _b = _a.name, name = _b === void 0 ? 'rxSearch' : _b, _c = _a.debounceTime, debounceTime = _c === void 0 ? 500 : _c;
    var config = forms.group(__assign(__assign({}, searchConfig), { controls: __assign({ page: forms.control([1]) }, searchConfig.controls) }));
    var _d = core.storeValue(build(config, {
        name: "rxSearchForm for ".concat(name),
        reducers: {
            changePage: function (_a, state, _b) {
                var updateValues = _a.updateValues;
                var payload = _b.payload;
                state = updateValues(state, {
                    controlRef: ['page'],
                    value: payload
                });
                return state;
            },
            fieldChangePageReset: function (_a, state, _b) {
                var updateValues = _a.updateValues;
                var _c = _b.payload, name = _c.name, value = _c.value;
                var controlRef = name === 'root' ? [] : name.split('.');
                state = updateValues(state, {
                    controlRef: controlRef,
                    value: value
                });
                state = updateValues(state, {
                    controlRef: ['page'],
                    value: 1
                });
                return state;
            }
        }
    })), searchForm$ = _d[0], searchFormActions = _d[1];
    var searchFormChange$ = searchForm$.pipe(operators.map(function (searchForm) { return searchForm.root.value; }), rxjs.distinctUntilChanged(isEqual__default["default"]), operators.tap(function (search) {
        onSearchChange && onSearchChange(search);
    }), operators.debounceTime(debounceTime));
    var searchResults$ = RxRequest({
        name: name,
        sources: [
            searchFormChange$.pipe(operators.map(function (payload) { return ({ type: 'send', payload: payload }); })),
        ],
        effect: function (action$) {
            return action$.pipe(operators.map(function (_a) {
                var payload = _a.payload;
                return rxjs.from(resource(payload));
            }));
        }
    })[0];
    var state$ = rxjs.combineLatest({
        searchResults: searchResults$,
        searchForm: searchForm$
    });
    var actions = {
        searchForm: searchFormActions
    };
    return [state$, actions];
};

var emptyAddress = {
    address: '',
    city: '',
    state: '',
    zip: ''
};
var emptyAddress2 = __assign(__assign({}, emptyAddress), { address2: '' });
var address = function (_a, required) {
    var _b = _a === void 0 ? emptyAddress : _a, address = _b.address, city = _b.city, state = _b.state, zip = _b.zip;
    if (required === void 0) { required = true; }
    return forms.group({
        controls: {
            address: forms.control([address, required ? ['required'] : []]),
            city: forms.control([city, required ? ['required'] : []]),
            state: forms.control([state, required ? ['required'] : []]),
            zip: forms.control({
                initialValue: zip,
                validators: ['zipCode'].concat(required ? 'required' : []),
                normalizers: ['normalizeZip']
            })
        }
    });
};
var address2Group = function (_a, required) {
    if (_a === void 0) { _a = emptyAddress2; }
    var address2 = _a.address2, address1 = __rest(_a, ["address2"]);
    if (required === void 0) { required = true; }
    return forms.group({
        controls: __assign(__assign({}, address(address1, required).controls), { address2: forms.control([address2]) })
    });
};

var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    address: address,
    address2Group: address2Group,
    emptyAddress: emptyAddress,
    emptyAddress2: emptyAddress2
});

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/**
 *@description selector will check to see if there are any
 *form controls (leaf in the form tree) in a form group that have been touched AND have an error
 */
var hasControlTouchError = function (form, groupName) {
    if (groupName === void 0) { groupName = 'root'; }
    var groupRef = groupName.split('.');
    var groupHasVisibleError = Object.values(form).some(function (control) {
        var isDescendentFormControl = (groupName === 'root' ||
            groupRef.every(function (key, index) { return key === control.controlRef[index]; })) &&
            // If it does not have child controls, it is a FormControl (leaf in the form tree)
            !control.config.controls;
        return isDescendentFormControl && control.touched && !control.valid;
    });
    return groupHasVisibleError;
};

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    hasControlTouchError: hasControlTouchError
});

exports.Configs = index$2;
exports.EXPIRED_QUOTE_VERSION = EXPIRED_QUOTE_VERSION;
exports.FormBuilders = formBuilders;
exports.Models = index$1;
exports.Reducers = index$3;
exports.RxBuilder = RxBuilder;
exports.RxPaginatedSearch = RxPaginatedSearch;
exports.RxQuoteLoader = RxQuoteLoader;
exports.RxQuoteSaver = RxQuoteSaver;
exports.RxRequest = RxRequest;
exports.RxTimer = RxTimer;
exports.RxToggle = RxToggle;
exports.Selectors = index;
exports.asyncValidator = asyncValidator;
exports.asyncValidators = asyncValidators;
exports.pollWhile = pollWhile;
exports.resetFormControls = resetFormControls;
exports.validatorFns = validatorFns;
